





































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppSmartSelect extends Vue {
  @Prop() readonly options!: { label: string; value: string | boolean }[]
  @Prop() readonly selected!: string
  @Prop() readonly buttonName!: string
  @Prop() readonly value: string | string[] | { value: string; status: string }[]
  @Prop({ default: () => { return false } }) readonly multiple: boolean
  @Prop() readonly multiLimit: number
  @Prop({ default: () => { return 3 } }) readonly cols: number
  @Prop({ default: () => { return true } }) readonly boxMode: boolean
  @Prop({ default: () => { return false } }) readonly cycleMode: boolean
  @Prop() readonly displayDirection: string
  @Prop({ default: () => { return false } }) readonly disabled: boolean

  flexDisplay () {
    if (this.displayDirection) {
      return {
        display: 'flex',
        'flex-direction': this.displayDirection
      }
    } else if (this.cols > 0) {
      return {
        display: 'grid',
        'grid-template-columns': `repeat(${this.cols}, 1fr)`,
        'grid-gap': '0.2rem'
      }
    }
    return {
      display: 'flex',
      'flex-direction': 'column'
    }
  }

  // empty block is excluded from block UI
  get blockOptions () {
    return this.options.filter(opt => opt.value !== '' && opt.label !== '')
  }

  /**
   * Very limited functionality here, we still have to define the classes at the
   * style of it before it is used.
   *
   * Some of the must have is that the options passed must have a status attribute.
   *
   */
  findStyle (option) {
    const valuePointer = this.value as { value: string; status: string}[]
    const found = valuePointer.find(current => current.value === option.value)
    if (found) {
      return option.status.indexOf(found.status)
    }
    return 0
  }

  /**
   * Very limited to do what it does. To note, the value structure must be
   * value: [
   *  {
   *    value: <value of the selected text>,
   *    status: <value of the status> // name of the attribute shall not be changed
   *  }
   * ]
   * the option that were selected will have this format, the name of the attributes shall not be changed
   * option: {
   *  label: <the label shown in the UI>,
   *  value: <the value of the selected text>,
   *  status: ['STATUS', 'EXAMPLE'] // it must be an array of strings
   * }
   */
  toggleCycleSelect (option) {
    const val = option.value
    if (this.disabled) return
    if (this.multiple) {
      if (!(this.value instanceof Array)) {
        console.error(`Incompatible : Expected 'value' to be array type but is ${typeof this.value}`)
        return
      }
      // already include
      const valuePointer = this.value as { value: string; status: string}[]
      const existedValue = valuePointer.find(currentValues => {
        if (currentValues.value === option.value) return currentValues
      })

      if (!existedValue) {
        if (this.multiLimit && (this.value.length + 1) > this.multiLimit) {
          alert(`Maximum ${this.multiLimit} can be selected.`)
          return
        }
        // Position 0 should always be the primary color button
        valuePointer.push({ value: option.value, status: option.status[0] })
        this.$emit('input', valuePointer)
        return
      }

      // If it already exists, cycle through the status
      const currentStatusIndex = option.status.indexOf(existedValue.status)
      if ((currentStatusIndex + 1) % option.status.length === 0) {
        this.$emit('input', valuePointer.filter(valu => valu.value !== option.value))
        return
      }

      this.$emit('input', valuePointer.map(current => {
        if (current.value === option.value) {
          return { value: option.value, status: option.status[currentStatusIndex + 1] }
        }
        return current
      }))
    } else {
      // This is not properly done. Will need to fix if we need to have a single select cycle value
      console.log(this.value, val)
      if (this.value !== val) this.$emit('input', val)
      else this.$emit('input', undefined)
    }
  }

  toggleSelect (val) {
    if (this.disabled) return
    if (this.multiple) {
      if (!(this.value instanceof Array)) {
        console.error(`Incompatible : Expected 'value' to be array type but is ${typeof this.value}`)
        return
      }
      // already include
      const valuePointer = this.value as string[]
      if (valuePointer.includes(val)) {
        this.$emit('input', valuePointer.filter(valu => valu !== val))
      } else {
        if (this.multiLimit && valuePointer.concat(val).length > this.multiLimit) {
          alert(`Maximum ${this.multiLimit} can be selected.`)
          return
        }
        this.$emit('input', valuePointer.concat(val))
      }
    } else {
      console.log(this.value, val)
      if (this.value !== val) this.$emit('input', val)
      else this.$emit('input', undefined)
    }
  }
}
